<script setup lang="ts">
import {CssClasses} from "../../types/ui";

const props = defineProps<{
	label: string;
	cssClass: CssClasses;
	isRequired: boolean;
	forId?: string;
}>();
</script>

<template>
	<label :for="props.forId" :class="[ props.cssClass, { 'forms__label--required': props.isRequired }]">{{
			props.label
		}}</label>
</template>

<style scoped>

</style>